<h1 mat-dialog-title>{{currentSection.name + ' - '+ getDownloadtitle()}}</h1>
<mat-dialog-content>
  <form [formGroup]="docDocumentFormGroup">
    <div>
      <mat-form-field *ngIf="currentSection.possibleEvidenceTypes.length > 1">
        <mat-label>
          {{ 'docDocuments.evidences' | transloco }}
        </mat-label>
        <mat-select formControlName="linkedEvidences" (selectionChange)="updateControls()" multiple [ngClass]="{ 'is-invalid': formControls.linkedEvidences.errors }">
            <mat-option *ngFor="let evidenceId of currentSection.possibleEvidenceTypes" [value]="possibleEvidences.get(evidenceId)?.id">{{possibleEvidences.get(evidenceId)?.name}}</mat-option>
        </mat-select>
        <mat-error *ngIf="formControls.linkedEvidences.hasError('required')">
          {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="input-field">
        <mat-label class="label-large">
          {{ 'docDocuments.name' | transloco }}
        </mat-label>
        <input #name matInput formControlName="name" autocomplete="off" type="text"
          [ngClass]="{ 'is-invalid': formControls.name.errors }">
        <mat-error *ngIf="formControls.name.hasError('required')">
          {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
        </mat-error>
        <mat-error *ngIf="formControls.name.hasError('pattern')">
          {{ 'dataManagement.userData.userDialog.validation.pattern' | transloco }}
        </mat-error>
      </mat-form-field>
      <div *ngIf="docDocumentFormGroup.value.linkedEvidences.length > 0">
        @for (evidence of docDocumentFormGroup.value.linkedEvidences; track evidence) {
          <div *ngIf="possibleEvidences.get(evidence)?.unit">
            <mat-form-field class="input-field rowInput">
              <mat-label class="label-large">
                {{possibleEvidences.get(evidence)?.name}}
              </mat-label>
              <input matInput type="number" [formControlName]="prefix_result+evidence">
              <span matSuffix>{{possibleEvidences.get(evidence)?.unit}}</span>
            </mat-form-field>
            <mat-form-field class="rowInput">
              <mat-label>{{ 'docDocuments.startDate' | transloco }}</mat-label>
              <input matInput autocomplete="off" [matDatepicker]="dpStart" [formControlName]="prefix_start+evidence">
              <mat-datepicker-toggle matSuffix [for]="dpStart"></mat-datepicker-toggle>
              <mat-datepicker #dpStart startView="multi-year">
              </mat-datepicker>
              <mat-error *ngIf="formControls[prefix_start+evidence].errors">
                <span *ngIf="formControls[prefix_start+evidence].errors?.endBeforeStart">
                  {{ 'dataEvaluation.performEvaluations.errors.endBeforeStart' | transloco }}
                </span>
             </mat-error>
            </mat-form-field>

            <mat-form-field class="rowInput">
              <mat-label>{{ 'docDocuments.endDate' | transloco }}</mat-label>
              <input matInput autocomplete="off" [matDatepicker]="dpEnd" [formControlName]="prefix_end+evidence">
              <mat-datepicker-toggle matSuffix [for]="dpEnd"></mat-datepicker-toggle>
              <mat-datepicker #dpEnd startView="multi-year">
              </mat-datepicker>
              <mat-error *ngIf="formControls[prefix_end+evidence].errors">
                <span *ngIf="formControls[prefix_end+evidence].errors?.endBeforeStart">
                  {{ 'dataEvaluation.performEvaluations.errors.endBeforeStart' | transloco }}
                </span>
             </mat-error>
            </mat-form-field>
          </div>
        }
      </div>
        <input type="file" accept=".pdf" (change)="onUploadDocClick(hiddenFileInput.files)" #hiddenFileInput
        onclick="value=null" style="display: none" />

        <button mat-raised-button (click)="hiddenFileInput.click()" color="primary" class="custom-button-top"
          type="button">
          <mat-icon class="material-icons left">add</mat-icon>
          {{ 'docDocuments.uploadFile' | transloco }}
        </button>
      <mat-form-field floatLabel="always" appearance="outline" class="input-field custom-height">
        <mat-label class="label-large">
          {{ 'docDocuments.comments' | transloco }}
        </mat-label>
        <textarea [placeholder]="getDefaultComment()"  matInput formControlName="comment"  maxlength="250" rows="7">
        </textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button (click)="doAction()" [disabled]="!enableSave" mat-raised-button type="submit"
    color="primary">{{ 'common.buttons.add' | transloco }}</button>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | transloco }}</button>
</mat-dialog-actions>
